import { c as _c } from "react/compiler-runtime";
import { getVideoEmbedSrc, VIDEO_EMBED_IFRAME_ALLOW } from "../../videoEmbed";
export type SanityVideoEmbedProps = {
  videoUrl: string;
  title?: string;
  className?: string;
};

/**
 * Renders a CMS video URL as a YouTube/Vimeo iframe, or a native `<video>` for direct file URLs.
 */
export function SanityVideoEmbed(t0) {
  const $ = _c(9);
  const {
    videoUrl,
    title: t1,
    className
  } = t0;
  const title = t1 === undefined ? "Embedded video" : t1;
  let t2;
  if ($[0] !== videoUrl) {
    t2 = getVideoEmbedSrc(videoUrl);
    $[0] = videoUrl;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const embedSrc = t2;
  if (embedSrc) {
    let t3;
    if ($[2] !== className || $[3] !== embedSrc || $[4] !== title) {
      t3 = <iframe src={embedSrc} title={title} allow={VIDEO_EMBED_IFRAME_ALLOW} allowFullScreen={true} className={className} />;
      $[2] = className;
      $[3] = embedSrc;
      $[4] = title;
      $[5] = t3;
    } else {
      t3 = $[5];
    }
    return t3;
  }
  let t3;
  if ($[6] !== className || $[7] !== videoUrl) {
    t3 = <video src={videoUrl} controls={true} playsInline={true} preload="metadata" className={className} />;
    $[6] = className;
    $[7] = videoUrl;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
}